import { Badge, Button } from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import type { KatalogEndpunkt } from '../gql/graphql.ts';
import type { AttributeToggle } from '../hooks/useKatalogAuswahl.ts';
import { AttributListe } from './AttributListe.tsx';

type AttributAuswahlMobilProps = {
  endpunkt: KatalogEndpunkt;
  gewaehlteAttribute: string[];
  onAttributToggle: (attributName: string) => void;
  onAlleSetzen: (attribute: AttributeToggle) => void;
  onFertig: () => void;
};

export function AttributAuswahlMobil({
  endpunkt,
  gewaehlteAttribute,
  onAttributToggle,
  onAlleSetzen,
  onFertig,
}: AttributAuswahlMobilProps) {
  const { t } = useTranslation();

  const alleGewaehlt = gewaehlteAttribute.length === endpunkt.attribute.length;

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-white">
      <div className="relative flex h-13 shrink-0 items-center justify-center px-4">
        <h1 className="text-sm font-semibold text-neutrals-900">
          {t('domain.e2nApi.neuerZugang.attributeTitel')}
        </h1>
        <Button
          variant="icon"
          size="icon"
          className="absolute right-2"
          onClick={onFertig}
          aria-label={t('domain.e2nApi.neuerZugang.attributeSchliessen')}>
          <FontAwesomeIcon icon={faXmark} />
        </Button>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-4">
        <div className="flex items-center gap-2">
          <Badge type="pill" variant="secondary" className="px-1">
            {endpunkt.httpMethode}
          </Badge>
          <span className="flex-1 truncate text-sm font-medium text-neutrals-900">
            {t('domain.e2nApi.neuerZugang.endpunktZaehler', {
              anzeigename: endpunkt.anzeigename,
              gewaehlt: gewaehlteAttribute.length,
              gesamt: endpunkt.attribute.length,
            })}
          </span>
          <Button
            variant="ghost-primary"
            onClick={() => onAlleSetzen(alleGewaehlt ? 'keine' : 'alle')}>
            {t(
              alleGewaehlt
                ? 'domain.e2nApi.neuerZugang.alleAbwaehlen'
                : 'domain.e2nApi.neuerZugang.alleAuswaehlen',
            )}
          </Button>
        </div>

        <AttributListe
          className="mt-3 pb-4"
          attribute={endpunkt.attribute}
          gewaehlteAttribute={gewaehlteAttribute}
          infoSeite="bottom"
          onToggle={onAttributToggle}
        />
      </div>

      <div className="shrink-0 border-t border-neutrals-200 p-4">
        <Button
          className="w-full"
          disabled={gewaehlteAttribute.length === 0}
          onClick={onFertig}>
          {t('domain.e2nApi.neuerZugang.weiter')}
        </Button>
      </div>
    </div>
  );
}
